import { Loader } from 'components/Loader/Loader'
import { StyledContainer } from 'components/Loader/Loader.Styled'

export const PageLoader = () => {
  return (
    <StyledContainer $isVisible>
      <Loader />
    </StyledContainer>
  )
}
